import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { IClientProperty } from '@clients/models/firebase/client.model';
import { PageSubtitleComponent } from '@shared/components/sections/page-subtitle/page-subtitle.component';
import { ModalService } from '@shared/services/modal/modal.service';

import { AddPropertyModalComponent } from '../modals/add-property-modal/add-property-modal.component';
import { EditPropertyModalComponent } from '../modals/edit-property-modal/edit-property-modal.component';

@Component({
	selector: 'app-desktop-client-create-property-table',
	imports: [CommonModule, PageSubtitleComponent],
	templateUrl: './desktop-client-create-property-table.component.html',
	styleUrl: './desktop-client-create-property-table.component.scss',
})
export class DesktopClientCreatePropertyTableComponent {
	@Input() properties: Array<IClientProperty>;
	private modalService = inject(ModalService);

	openAddProperty(): void {
		const modalRef = this.modalService.open(AddPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as AddPropertyModalComponent;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.properties.push(property);
		});
	}

	openEditProperty(clientProperty: IClientProperty, index: number): void {
		const modalRef = this.modalService.open(EditPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as EditPropertyModalComponent;
		componentInstance.clientProperty = clientProperty;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.properties[index] = property;
		});
		componentInstance.propertyRemoved.pipe(take(1)).subscribe(() => {
			this.properties.splice(index, 1);
		});
	}
}
